import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthenticationService } from '../../../services/auth/authentication.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/app/services/api/common.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MixpanelService } from 'src/app/mixpanel.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { GroupService } from 'src/app/services/api/group.services';
import { TeacherBookingService } from 'src/app/services/api/consumer/bookings.service';
import { PaginationComponent } from 'ngx-bootstrap/pagination';
import { PageChangedEvent } from 'ngx-bootstrap/pagination/public_api';
import { CommonModule } from '@angular/common';
import { SettingsService } from 'src/app/services/api/consumer/settings.service';
import { SchoolData } from 'src/app/models/schoolUser';
import { ArticleComponent } from '../../producer/article/article.component';
import { StatusPopupService } from 'src/app/services/api/status-popup.service';
import { ProfileService } from 'src/app/services/api/consumer/profile.service';
import { take } from "rxjs/operators";

import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { an, el, em } from '@fullcalendar/core/internal-common';
declare var bootstrap: any;

@Component({
  selector: 'app-settings',
  standalone: true,
  imports: [
    PaginationComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ArticleComponent,
  ],
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.scss',
})
export class SettingsComponent {
  public bookingNotiSettings: any;
  public emailEditForm: any;
  public accountSettingsForm: any;
  public updateEmailForm: any;
  public passwordResetSettingsForm: any;
  settingsData: any;
  activeTab: string = ''; // default tab
  @ViewChild('YourEmailEditModalComponent') YourEmailEditModalComponent: any;
  @ViewChild('updateEmailModal') updateEmailModal: any;
  @ViewChild('deactivateSuccessModal') deactivateSuccessModal: any;
  @ViewChild('MFAVerificationModalTemplate') MFAVerificationModalTemplate: any;
  @ViewChild('DisableMFAModalTemplate') DisableMFAModalTemplate: any;
  isPasswordButtonEnabled: boolean = false; // Add this line
  showCurrentPassword: boolean = false;
  showNewPassword: boolean = false;
  showConfirmPassword: boolean = false;
  deactivateAccountForm: any;
  selectedJobAlertFrequency: string | number = ''; // set default if needed
  selectedSchoolType: string | number = '';
  selectedDistance: string | number = '';
  selectedJobType: string | number = '';
  selectedSchoolLevel: any[] = []; // initialize as array
  selectedRoleType: any[] = []; // initialize as array
  postCodes: any = [''];
  job_alert_frequency: any = [
    { id: 1, name: 'Daily', value: '0' },
    { id: 2, name: 'Weekly', value: '1' },
  ];
  school_level: any = [
    { id: 1, name: 'ALL', value: 'ALL' },
    { id: 2, name: 'Primary School', value: 'PS' },
    { id: 3, name: 'Secondary School', value: 'SS' },
    { id: 4, name: 'Early Childhood', value: 'EC' },
    { id: 5, name: 'Special', value: 'S' },
  ];
  // role_type: any = [
  //   { id: 1, name: 'Primary', value: 'primary' },
  //   { id: 2, name: 'Secondary', value: 'secondary' },
  // ];
  school_type: any = [
    { id: 1, name: 'ALL', value: 'ALL' },
    { id: 2, name: 'Catholic', value: 'C' },
    { id: 3, name: 'Government', value: 'G' },
    { id: 4, name: 'Private', value: 'P' },
    { id: 5, name: 'Special', value: 'S' },
  ];
  job_type: any = [
    { id: 1, name: 'ALL', value: 'ALL' },
    { id: 2, name: 'Casual', value: 'C' },
    { id: 3, name: 'Job Share', value: 'JS' },
    { id: 4, name: 'Part Time', value: 'PT' },
    { id: 5, name: 'Full Time', value: 'FT' },
    { id: 6, name: 'Contract', value: 'CO' },
  ];
  distance: any = [
    { id: 0, name: 'Any', value: '10000000' },
    { id: 1, name: '< 5km', value: '5' },
    { id: 2, name: '< 10km', value: '10' },
    { id: 3, name: '< 20km', value: '20' },
    { id: 4, name: '< 50km', value: '50' },
    { id: 5, name: '< 250km  ', value: '250' },
  ];
  availabilitySwitch1: boolean = false; // For the first switch
  availabilitySwitch2: boolean = false; // For the second switch
  bookings_on_off: boolean = false; // For the first switch
  deactivateReasons = [
    { value: 'NLT', label: 'I’m no longer working on a casual basis' },
    {
      value: 'HSP',
      label: 'I have secured a temporary/permanent position  ',
    },
    { value: 'OEL', label: 'I’m on extended leave' },
    { value: 'NGEW', label: 'Did not get enough work through CC' },
    { value: 'O', label: 'Others' },
  ];
  public schoolProps!: SchoolData;
  deleteDeactivate: string = '';
  enterEmail: string = '';
  email_daily: any = 0;
  email_weekly: any = 0;
  otpCode: any;
  isMfaEnabled: boolean = false;
  isOtpValid: boolean = false;
  userEmail: any;
  constructor(
    private fb: FormBuilder,
    private _router: Router,
    private authService: AuthenticationService,
    private commonService: CommonService,
    private ngxService: NgxUiLoaderService,
    private modalService: BsModalService,
    private toastr: ToastrService,
    public bsModalRef: BsModalRef,
    private SettingsService: SettingsService,
    private popup: StatusPopupService,
    private ProfileService: ProfileService,
  ) { }

  ngOnInit(): void {
    this.ngxService.start();
    if (!this.schoolProps?.properties?.job_only_teacher) {
      this.activeTab = 'booking-notifications'; // Set default active tab on init
    } else {
      this.activeTab = 'job-notifications'; // Set default active tab on init
    }
    this.schoolProps = JSON.parse(localStorage.getItem('userData') || '{}');
    this.isMfaEnabled = this.schoolProps?.properties?.mfa_enabled || false;
    this.SettingsService.settingsPageAPI('').subscribe({
      next: (res: any) => {
        if (res.status) {
          // console.log('k', res.data)
          this.settingsData = res.data;
          this.setSettingsValues(res.data);
          this.ngxService.stop();
        } else {
          this.toastr.error(res.message, 'Error');
          this.ngxService.stop();
        }
      },
      error: (err: any) => {
        console.log(err);
        this.ngxService.stop();
      },
    });
    this.formInit();
    this.deactivateAccountForm = this.fb.group({
      reason: [this.deactivateReasons[0].value],
    });
  }


  ngAfterViewInit() {
    const tooltipTriggerList = Array.from(document.querySelectorAll('[data-bs-toggle=\"tooltip\"]'));
    tooltipTriggerList.forEach((tooltipTriggerEl) => {
      new bootstrap.Tooltip(tooltipTriggerEl);
    });
  }

  onLoad() {
    this.ngxService.start();
    this.schoolProps = JSON.parse(localStorage.getItem('userData') || '{}');

    this.SettingsService.settingsPageAPI('').subscribe({
      next: (res: any) => {
        if (res.status) {
          // console.log('k', res.data)
          this.settingsData = res.data;
          this.setSettingsValues(res.data);
          this.ProfileService.setStatus(this.bookings_on_off);
          this.ngxService.stop();
        } else {
          this.toastr.error(res.message, 'Error');
          this.ngxService.stop();
        }
      },
      error: (err: any) => {
        console.log(err);
        this.ngxService.stop();
      },
    });
    this.formInit();
    this.deactivateAccountForm = this.fb.group({
      reason: [this.deactivateReasons[0].value],
    });
  }
  setSettingsValues(data: any) {
    // When initializing the form, convert 1/0 to boolean
    this.bookingNotiSettings = this.fb.group({
      email_day_before: [
        !!data?.notification.email_day_before,
        [Validators.required],
      ],
      sundays_with_breakdown: [
        !!data?.notification.sundays_with_breakdown,
        [Validators.required],
      ],
      sunday_as_reminder_to_update: [
        !!data?.notification.sunday_as_reminder_to_update,
        [Validators.required],
      ],
      reminder_if_29_days: [
        !!data?.notification.reminder_if_29_days,
        [Validators.required],
      ],
      sms: [!!data?.notification.sms, [Validators.required]],
    });
    this.accountSettingsForm = this.fb.group({
      profile_viewable: [
        !!data?.view_settings.profile_viewable,
        [Validators.required],
      ],
      permanent_role: [
        !!data?.other_settings.permanent_role,
        [Validators.required],
      ],
      user_email: [data?.user_email, [Validators.required, Validators.email]],
    });
    this.selectedRoleType = this.selectedRoleType =
      data?.job_settings.role_type || [];

    this.selectedSchoolLevel = data?.job_settings.school_level || [];
    this.selectedSchoolType = data?.job_settings.school_type || '';
    this.selectedJobType = data?.job_settings.job_type || '';
    this.selectedDistance = data?.job_settings?.job_distance?.toString() || '';
    this.postCodes = data?.job_settings.post_code || '';
    this.availabilitySwitch1 = !!data?.job_settings.is_show_headhunter;
    this.availabilitySwitch2 = !!data?.job_settings.email_job_alert_near;
    this.bookings_on_off = data?.booking_status === '1';
    if (data?.job_settings.email_daily === 0) {
      this.selectedJobAlertFrequency = '0';
    }
    if (data?.job_settings.email_weekly === 1) {
      this.selectedJobAlertFrequency = '1';
    }
    if (data?.job_settings.email_daily === 1) {
      this.selectedJobAlertFrequency = '1';
    }
    if (data?.job_settings.email_weekly === 0) {
      this.selectedJobAlertFrequency = '0';
    }
  }

  // Method to set the active tab
  setActiveTab(tab: string) {
    this.activeTab = tab;
    return this.activeTab;
  }

  formInit() {
    this.bookingNotiSettings = this.fb.group({
      action: [''],
      reminder_if_29_days: ['', [Validators.required]],
      sundays_with_breakdown: ['', [Validators.required]],
      sunday_as_reminder_to_update: ['', [Validators.required]],
      email_day_before: ['', [Validators.required]],
      sms: ['', [Validators.required]],
    });

    this.accountSettingsForm = this.fb.group({
      action: [''],
      profile_viewable: ['', [Validators.required]],
      permanent_role: ['', [Validators.required]],
      user_email: [''],
    });
    this.emailEditForm = this.fb.group({
      password: [''],
    });
    this.updateEmailForm = this.fb.group({
      new_email: ['', [Validators.required, Validators.email]],
      confirm_email: ['', [Validators.required, Validators.email]],
    });
    this.passwordResetSettingsForm = this.fb.group({
      action: [''],
      current_password: ['', [Validators.required]],
      new_password: ['', [Validators.required, Validators.minLength(6)]],
      confirm_password: ['', [Validators.required]],
    });
    this.deactivateAccountForm = this.fb.group({
      action: ['deactivate_account'],
      reason: [''],
    });
  }
  getFormControlValues() {
    if (this.activeTab == 'booking-notifications') {
      const formValue = this.bookingNotiSettings.value;
      return {
        ...formValue,
        action: 'booking_notification',
        email_day_before: formValue.email_day_before ? 1 : 0,
        sundays_with_breakdown: formValue.sundays_with_breakdown ? 1 : 0,
        sunday_as_reminder_to_update: formValue.sunday_as_reminder_to_update
          ? 1
          : 0,
        reminder_if_29_days: formValue.reminder_if_29_days ? 1 : 0,
        sms: formValue.sms ? 1 : 0,
      };
    } else if (this.activeTab == 'account-settings') {
      const formValue = this.accountSettingsForm.value;
      return {
        ...formValue,
        action: 'account_settings',
        profile_viewable: formValue.profile_viewable ? 1 : 0,
        permanent_role: formValue.permanent_role ? 1 : 0,
        user_email: formValue.user_email,
      };
    }
    return {};
  }

  getAllSettingsValues() {
    if (this.selectedJobAlertFrequency === '0') {
      this.email_daily = 1;
      this.email_weekly = 0;
    }
    if (this.selectedJobAlertFrequency === '1') {
      this.email_daily = 0;
      this.email_weekly = 1;
    }
    // Validation: if post_code is not empty, distance cannot be 'Any' (10000000)
    const postCodeFilled = Array.isArray(this.postCodes)
      ? this.postCodes.some((p: any) => p && p.trim() !== '')
      : (this.postCodes && this.postCodes.trim() !== '');
    if (postCodeFilled && this.selectedDistance === '10000000') {
      return { error: 'If you enter a post code, you must select a distance other than Any.' };
    }
    return {
      // Job notification switches
      action: 'job_notification',
      is_show_headhunter: this.availabilitySwitch1 ? 1 : 0,
      email_job_alert_near: this.availabilitySwitch2 ? 1 : 0,

      // Job alert frequency (single select)
      email_weekly: this.email_weekly,
      email_daily: this.email_daily,

      // School level (multi-select)
      school_level: this.selectedSchoolLevel, // array

      // School type (single select)
      school_type: this.selectedSchoolType,

      // Job type (single select)
      job_type: this.selectedJobType,

      // Distance (single select)
      job_distance: this.selectedDistance,

      // Role type (multi-select)
      role_type: this.selectedRoleType, // array

      // Post codes (string or array)
      post_code: this.postCodes,
    };
  }

  SubmitForm() {
    this.ngxService.start();
    this.SettingsService.sendSettingsPageAPI(
      this.getFormControlValues()
    ).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.bsModalRef.hide();
          this.toastr.success(res.message);
          this.onLoad();
        } else {
          // this.modalService.hide()
          this.toastr.error(res.message);
        }
        this.ngxService.stop();
      },
      error: (err: any) => {
        console.log(err);
        this.ngxService.stop();
      },
    });
  }
  openEmailEditModal() {
    // Open your modal here
    this.bsModalRef = this.modalService.show(this.YourEmailEditModalComponent, {
      class: 'modal-md',
      backdrop: 'static',
    });
  }
  openConfirmEmailModal() {
    // Open your modal here
    this.bsModalRef = this.modalService.show(this.YourEmailEditModalComponent, {
      class: 'modal-md',
      backdrop: 'static',
    });
  }
  openUpdateEmailModal() {
    // Open your modal here
    this.bsModalRef = this.modalService.show(this.updateEmailModal, {
      class: 'modal-md',
      backdrop: 'static',
    });
  }
  confirmEmailEdit() {
    const data = {
      action: 'password',
      password: this.emailEditForm.get('password')?.value,
    };
    // Pass password to your API call
    this.SettingsService.passwordValidationAPI(data).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.bsModalRef.hide();
          this.openUpdateEmailModal();
        } else {
          // this.modalService.hide()
          this.toastr.error(res.message);
        }
        this.ngxService.stop();
      },
      error: (err: any) => {
        console.log(err);
        this.ngxService.stop();
      },
    });
  }
  updateEmail() {
    this.ngxService.start();
    const data = {
      action: 'update_email',
      new_email: this.updateEmailForm.get('new_email')?.value,
      confirm_email: this.updateEmailForm.get('confirm_email')?.value,
    };
    // Pass password to your API call
    this.SettingsService.updateEmailAPI(data).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.bsModalRef.hide();
          this.toastr.success(res.message);
          setTimeout(() => {
            this.authService.loggedOutOnUpdate();
          }, 4000);
          // this.onLoad();
        } else {
          // this.modalService.hide()
          this.toastr.error(res.message);
          this.ngxService.stop();
        }
      },
      error: (err: any) => {
        console.log(err);
        this.ngxService.stop();
      },
    });
  }
  removeReadonly(event: any) {
    event.target.removeAttribute('readonly');
  }
  updatePasswordSubmit() {
    this.ngxService.start();
    this.passwordResetSettingsForm.patchValue({
      action: 'password_reset',
    });
    this.SettingsService.sendSettingsPageAPI(
      this.passwordResetSettingsForm.value
    ).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.toastr.success(res.message || 'Password updated successfully');
          setTimeout(() => {
            this.authService.loggedOutOnUpdate();
          }, 4000);
          // this.onLoad();
          // this.isPasswordButtonEnabled = false; // Reset button state
          // this.passwordResetSettingsForm.reset(); // Reset form fields
          // this.ngxService.stop();
        } else {
          this.onLoad();
          this.toastr.error(res.message || 'Failed to update password');
          this.ngxService.stop();
        }
      },
      error: (err: any) => {
        this.toastr.error(err.message || 'Failed to update password');
        this.ngxService.stop();
        console.log(err);
      },
    });
  }

  toggleSchoolLevel(value: any) {
    const idx = this.selectedSchoolLevel.indexOf(value);
    if (idx === -1) {
      this.selectedSchoolLevel.push(value);
    } else {
      this.selectedSchoolLevel.splice(idx, 1);
    }
  }
  toggleRoleType(value: any) {
    const idx = this.selectedRoleType.indexOf(value);
    if (idx === -1) {
      this.selectedRoleType.push(value);
    } else {
      this.selectedRoleType.splice(idx, 1);
    }
  }
  submitJobNotificationSettings() {
    // Check if postCodes is empty or contains only empty strings
    // if (
    //   !this.postCodes ||
    //   (Array.isArray(this.postCodes) &&
    //     this.postCodes.filter((p: any) => p && p.trim() !== '').length === 0)
    // ) {
    //   this.toastr.error('Post code should not be empty');
    //   return;
    // }
    const payload = this.getAllSettingsValues();
    if (payload.error) {
      this.toastr.error(payload.error);
      return;
    }
    this.ngxService.start();
    this.SettingsService.sendSettingsPageAPI(payload).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.toastr.success(res.message);
          this.onLoad();
        } else {
          this.toastr.error(res.message);
          this.ngxService.stop();
        }
      },
      error: (err: any) => {
        this.toastr.error(err.message);
        this.onLoad();
        this.ngxService.stop();
        console.log(err);
      },
    });
  }
  submitDeactivateAccount(type: string) {
    const selectedReason = this.deactivateAccountForm.get('reason')?.value;
    let data: any = '';
    if (type === 'deleted') {
      if (this.enterEmail.trim() === '') {
        this.toastr.error('Please enter your email address.');
        return;
      }
      if (this.enterEmail !== this.settingsData.user_email) {
        this.toastr.error(
          'The entered email does not match your account email.'
        );
        return;
      }
      data = {
        email: this.enterEmail,
      };

      this.SettingsService.deleteAccountAPI(data).subscribe({
        next: (res: any) => {
          if (res.status) {
            if(res?.is_upcoming_booking){
              this.popup.warning({
                title: 'Delete Account',
                content: 'You have upcoming bookings. Please cancel them before deleting your account.',
              });
              return;
            }
            this.deleteDeactivate = type;
            this.bsModalRef = this.modalService.show(
              this.deactivateSuccessModal,
              {
                class: 'modal-md',
                backdrop: 'static',
              }
            );            
            // Optionally, navigate away or perform other actions
          } else {
            this.toastr.error(res.message);
          }
        },
        error: (err: any) => {
          this.toastr.error(err?.error?.message || 'Something went wrong while deleting account');
          console.log(err);
        },
      });
    } else {
      if (type === 'deactivated') {
        data = {
          reason: selectedReason,
          action: 'deactivate',
        };
      } else if (type === 'activated') {
        data = {
          reason: selectedReason,
          action: 'activate',
        };
      }
      this.ngxService.start();
      this.SettingsService.activateAccountAPI(data).subscribe({
        next: (res: any) => {
          this.ngxService.stop();
          if (res.status) {
            this.deleteDeactivate = type;
            this.bsModalRef = this.modalService.show(
              this.deactivateSuccessModal,
              {
                class: 'modal-md',
                backdrop: 'static',
              }
            );
            let currentUrl = this._router.url;
            this._router
              .navigateByUrl('/', { skipLocationChange: true })
              .then(() => {
                this._router.navigate([currentUrl]);
              });
            // Optionally, navigate away or perform other actions
          } else {
            // this.toastr.error(res.message);
            this.popup.warning({
              title: 'Deactivate Account',
              content: res.message,
            });

          }
        },
        error: (err: any) => {
          this.toastr.error(err?.error?.message || 'Something went wrong while deleting account');
          console.log(err);
        },
      });
    }
  }
  closePasswordModal() {
    this.bsModalRef.hide();
    this.emailEditForm.patchValue({
      password: '',
    });
    this.updateEmailForm.patchValue({
      new_email: '',
      confirm_email: '',
    });
  }
  onBookingsOnOffChange(value: boolean) {
    this.ngxService.start();
    // Call your API here
    this.SettingsService.profileUpdateAPI({
      using_cc_to_B: value ? 1 : 0,
      from: 'usingCCToDetails',
    }).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.toastr.success(res.message);
          this.onLoad();
        } else {
          this.toastr.error(res.message);
          this.onLoad();
        }
      },
      error: (err: any) => {
        this.toastr.error('Something went wrong');
        this.onLoad();
        console.error(err);
      },
    });
  }

  onOtpChange() {
    this.otpCode = this.otpCode.replace(/\D/g, '');
    this.isOtpValid = this.otpCode.length === 6;
  }
  enableMFA(): void {
    this.otpCode = '';
    this.isOtpValid = false;
    this.ngxService.start();
    this.commonService.enableMFA()
      .pipe(take(1))
      .subscribe({
        next: (res) => {
          this.ngxService.stop();
          if (res.status) {
            this.bsModalRef = this.modalService.show(
              this.MFAVerificationModalTemplate,
              { class: 'modal-md', backdrop: 'static' }
            );
            this.userEmail = res.email;
            this.toastr.success(res.message);
          }
          else {
            this.toastr.error(res.message);
            // show error notification if needed
          }
        },
        error: (err) => {
          this.toastr.error(err.message);
          this.ngxService.stop();
          // show error notification if needed
        }
      });
  }
  verifyAndEnableMFA(): void {

    const payload = {
      otp: this.otpCode,
      enable_mfa: true
    };

    this.ngxService.start();

    this.commonService.enableMfaOtpVerifyAPI(payload).subscribe({
      next: (res: any) => {
        this.ngxService.stop();

        if (res.status) {
          this.isMfaEnabled = res.mfa_enabled;
          const userData = JSON.parse(localStorage.getItem("userData") || "{}");

          if (userData?.properties) {
            userData.properties.mfa_enabled = res.mfa_enabled;
          }

          localStorage.setItem("userData", JSON.stringify(userData));
          this.bsModalRef.hide();
          this.toastr.success(res.message);
        }
        else {
          this.toastr.error(res.message);
        }
      },
      error: (err) => {
        this.ngxService.stop();
        this.toastr.error(err.message);
      }
    });
  }
  showDisableMFAModal(): void {
    this.bsModalRef = this.modalService.show(
      this.DisableMFAModalTemplate,
      { class: 'modal-md', backdrop: 'static' }
    );
  }
  disableMFA(): void {
    this.ngxService.start();
    this.commonService.disableMFA()
      .pipe(take(1))
      .subscribe({
        next: (res) => {
          this.ngxService.stop();
          if (res.status) {
            this.isMfaEnabled = res.mfa_enabled;
            const userData = JSON.parse(localStorage.getItem("userData") || "{}");

            if (userData?.properties) {
              userData.properties.mfa_enabled = res.mfa_enabled;
            }

            localStorage.setItem("userData", JSON.stringify(userData));
            this.bsModalRef.hide();
            this.toastr.success(res.message);
          }
          else {
            this.toastr.error(res.message);
          }
        },
        error: (err) => {
          this.toastr.error(err.message);
          this.ngxService.stop();
        }
      });
  }
  resendOtp(): void {
    this.ngxService.start();
    this.commonService.resendMFAOtp("")
      .pipe(take(1))
      .subscribe({
        next: (res) => {
          this.ngxService.stop();
          if (res.status) {
            this.toastr.success(res.message);
          }
          else {
            this.toastr.error(res.message);
          }
        },
        error: (err) => {
          this.toastr.error(err.message);
          this.ngxService.stop();
        }
      });
  }
  handlePageData(data: any) {
    // Store the page data for later use, e.g. pagination or display
    this.pageData = data;
    // Optionally, update the UI or trigger other logic if needed
    // Example: this.obsArray.next(data.consumer_list || []);
  }
  pageData: any;

  redirectToLogin() {
    this.bsModalRef.hide();
    this.authService.loggedOutOnUpdate();
  }

}
function ngAfterViewInit() {
  throw new Error('Function not implemented.');
}

